import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import IconEmail from '@atlaskit/icon/glyph/email';
import IconLocation from '@atlaskit/icon/glyph/location';
import OfficeBuildingIcon from '@atlaskit/icon/glyph/office-building';
import IconRecent from '@atlaskit/icon/glyph/recent';
import { DetailsLabel, DetailsLabelIcon, DetailsLabelText } from '../../styled/Card';
var icons = {
  location: IconLocation,
  time: IconRecent,
  email: IconEmail,
  companyName: OfficeBuildingIcon
};
var IconLabel = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(IconLabel, _React$PureComponent);
  var _super = _createSuper(IconLabel);
  function IconLabel() {
    _classCallCheck(this, IconLabel);
    return _super.apply(this, arguments);
  }
  _createClass(IconLabel, [{
    key: "render",
    value: function render() {
      if (!this.props.children) {
        return null;
      }

      // @ts-ignore
      var IconElement = this.props.icon && icons[this.props.icon];
      var displayIcon = IconElement ? /*#__PURE__*/React.createElement(IconElement, {
        label: "".concat(this.props.icon),
        size: "small"
      }) : null;
      return /*#__PURE__*/React.createElement(DetailsLabel, null, /*#__PURE__*/React.createElement(DetailsLabelIcon, null, displayIcon), /*#__PURE__*/React.createElement(DetailsLabelText, null, this.props.children));
    }
  }]);
  return IconLabel;
}(React.PureComponent);
_defineProperty(IconLabel, "defaultProps", {
  icon: ''
});
export { IconLabel as default };